export const REGEX = {
  SCHOOL: /^[a-z]{3}[0-9]{2}$/,
  FACULTY: /^[a-z]{2}$/,
  COURSE: /^[0-9]{2}$/,
  PERSONAL_ID: /^[0-9]{4}$/,
  PASSWORD: /^.{6,14}$/,
  NOT_WHITESPACE: /^(?!.*[\s])/,
};
